import { CdvType } from "@enums";
import type { IHubCdv, IHubUserPermissionsResponse } from "@models";
import { HARDCODED_PORTAL_PERMISSIONS } from "../constants/hubPermissions";

/**
 * Maps the API permissions response to the internal DXP Hub permissions format
 * based on the role mapping.
 */
export function mapApiPermissionsToHubPermissions(
  apiResponse?: IHubUserPermissionsResponse,
): string[] {
  if (!apiResponse?.roles) {
    return [];
  }

  const permissionsSet = new Set<string>();

  apiResponse.roles.forEach((roleObj) => {
    let roleKey = roleObj.role;

    // Handle ADMIN role based on isInternal flag
    if (
      roleKey === "COMPANY_ADMIN" &&
      apiResponse?.isInternal != null &&
      apiResponse?.isInternal === true
    ) {
      roleKey = "INTERNAL";
    }

    if (roleKey) {
      const rolePermissions =
        HARDCODED_PORTAL_PERMISSIONS.roles[
          roleKey as keyof typeof HARDCODED_PORTAL_PERMISSIONS.roles
        ] || HARDCODED_PORTAL_PERMISSIONS.roles.STANDARD_USER;

      rolePermissions.forEach((p) => {
        permissionsSet.add(p);
      });
    }
  });

  return Array.from(permissionsSet);
}

export function isCatalogTypePermittedByCdvEmail(
  userEmail: string | undefined,
  cdvs: IHubCdv[],
): boolean {
  if (!userEmail) return false;

  const normalizedEmail = userEmail.toLowerCase();
  return cdvs.some(
    (cdv) =>
      cdv.type === CdvType.CatalogTypePermittedEmails &&
      (cdv.name || "").toLowerCase() === normalizedEmail,
  );
}
